var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    [
      _c("b-row", [
        _c(
          "div",
          [
            _c(
              "b-alert",
              {
                staticClass: "text-center font-weight-bold texto-informativo",
                attrs: {
                  show: !this.revision?.respuesta?.confirmaClonacion,
                  variant: "warning",
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      "¿Desea replicar la recomendación de alguna de las personas evaluadoras?"
                    ) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-alert",
              {
                staticClass: "text-center font-weight-bold texto-informativo",
                attrs: {
                  show: _vm.clonado && !_vm.evaluacionGuardadaFinal,
                  variant: "warning",
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      'Deberá presionar el botón de "seleccionar" en la pestaña de la persona evaluadora a replicar.'
                    ) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            !this.revision?.respuesta?.confirmaClonacion
              ? _c(
                  "b-button",
                  {
                    staticClass: "btn-confirmacion btn-confirmacion-guinda",
                    on: {
                      click: function ($event) {
                        return _vm.confirmarClonado("SI")
                      },
                    },
                  },
                  [_vm._v("\n        Sí\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            !this.revision?.respuesta?.confirmaClonacion
              ? _c(
                  "b-button",
                  {
                    staticClass: "btn-confirmacion btn-confirmacion-guinda",
                    on: {
                      click: function ($event) {
                        return _vm.confirmarClonado("NO")
                      },
                    },
                  },
                  [_vm._v("\n        No\n      ")]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "b-tabs",
              { attrs: { "content-class": "mt-3" } },
              _vm._l(_vm.revisiones, function (item, index) {
                return _c(
                  "b-tab",
                  {
                    key: "dyn-tab-" + item.revisor.revisorId,
                    attrs: { title: item.revisor.revisorId, active: "" },
                  },
                  [
                    _c(
                      "b-container",
                      [
                        _c(
                          "b-row",
                          [
                            _c("h1", [
                              _vm._v("Evaluación " + _vm._s(index + 1)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _vm.clonado && !_vm.evaluacionGuardadaFinal
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "btn-confirmacion btn-confirmacion-guinda",
                                        attrs: {
                                          disabled:
                                            _vm.hasAnyAuthority(
                                              "ROLE_OPERADOR"
                                            ) && _vm.authenticated,
                                          variant: "primary",
                                          size: "md",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.seleccionarRevision(
                                              item,
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("Seleccionar")) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card-text",
                      [
                        _c("h3", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("evaluacion-individual.title")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _vm.solucionTipoIngreso || _vm.solucionTipoDiaspora
                          ? _c("evaluacion-individual-2026", {
                              attrs: {
                                solucionPlenaria: _vm.solucion,
                                solicitud: _vm.solicitud,
                                revision: item,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("h3", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("evaluacion-individual.dictamen")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _vm.solucionTipoIngreso
                          ? _c("dictamen-2026", {
                              attrs: {
                                solicitud: _vm.solicitud,
                                revision: item,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.solucionTipoDiaspora
                          ? _c("dictamen-diaspora", {
                              attrs: {
                                solicitud: _vm.solicitud,
                                revision: item,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }